(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Product cards stamp their anchor onto the collection URL when opened, so that deep
  // links land on the right card. Going back through history brings that hash along, but
  // there the browser already restores the exact scroll position — scrolling the card to
  // the top of the viewport on top of that is what displaces the whole page.
  const isTraversal = () => {
    const activation = window.navigation?.activation

    if (activation) return activation.navigationType === 'traverse'

    // Safari has no Navigation API
    const [entry] = performance.getEntriesByType('navigation')

    return entry?.type === 'back_forward'
  }

  const url = new URL(window.location.href)
  if (url.hash && !isTraversal()) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1))
        if (card) {
          card.scrollIntoView({ behavior: 'instant' })
        }
      },
      { once: true },
    )
  }

  } catch(e) { console.error(e); }
})();
})();
